<!--suppress CheckEmptyScriptTag -->
<template>
  <div>
    <q-form class="q-gutter-xs" ref="form">
<div class="text-bold">Shipping Details</div>    
<div class="row">
    <q-input v-model="value.shippingDetails.contactName" class="col" dense outlined label="Name" :rules="[ val => val && val.length > 0|| 'Name is required']" />
</div>
<div class="row">
    <q-input v-model="value.shippingDetails.contactLastname" class="col" dense outlined label="Lastname" :rules="[ val => val && val.length > 0|| 'Lastname is required']"/>
</div>
<div class="row">
    <q-input v-model="value.shippingDetails.company" class="col" dense outlined label="Company (Optional)" :rules="[]"/>
</div>
<div class="row">
    <q-input v-model="value.shippingDetails.address" class="col" dense outlined label="Address" :rules="[ val => val && val.length > 0|| 'Address is required']" />
</div>
<div class="row">
    <q-input v-model="value.shippingDetails.address2" class="col" dense outlined label="Apartment, suite, etc. (Optional)" :rules="[]"/>
</div>
<div class="row">
    <q-input v-model="value.shippingDetails.city" class="col" dense outlined label="City" :rules="[ val => val && val.length > 0|| 'City is required']" />
</div>
<div class="row">
    <q-input v-model="value.shippingDetails.phoneNumber" class="col" dense outlined label="Phone Number" :rules="[ val => val && val.length == 12 || 'Phone number is required']" mask="##-####-####" hint="e.g: 04-1234-5678" lazy-rules/>
</div>        
<div>
    <div class="row q-col-gutter-md">
        <q-input v-model="value.shippingDetails.country" class="col-xs-12 col-sm-4" dense outlined label="Country" :disable="true" :rules="[val => !!val || 'Country is required']" />
        <q-select v-model="value.shippingDetails.state" class="col-xs-6 col-sm-4" dense outlined label="State" :options="filteredStateOptions" use-input fill-input hide-selected @filter="filterFn" ref="state" :rules="[val => !!val || 'State is required']" />
        <q-input v-model="value.shippingDetails.postCode" class="col-xs-6 col-sm-4" dense outlined label="Postcode" mask="####" :rules="[val => !!val || 'Postcode is required', val => val.length === 4 || 'Postcode must have 4 digits']" lazy-rules />
    </div>
</div>
<div v-if="!isLoggedIn">
    <div class="text-bold">Account details</div>
    <div class="row">
        <q-input v-model="value.registrationDetails.contactName" class="col-xs-12 col-sm-6" dense outlined label="Your Name" type="text" :rules="[ val => val && val.length > 0 || 'Please enter your name.' ]"/>
        <q-input v-model="value.registrationDetails.email" class="col-xs-12 col-sm-6" dense outlined label="Email" type="email" lazy-rules :rules="[ val => val && val.length > 0 && validateEmail(val) || 'Please enter a valid email address.' ]"/>
    </div>
    <div class="row"> 
        <q-input v-model="value.registrationDetails.password" class="col-xs-12 col-sm-6" dense outlined label="Password" type="password"  autocomplete="new-password" lazy-rules :rules="[ val => val && val.length > 7 || 'Please enter a password of at least 8 characters.' ]"/>
        <q-input v-model="value.registrationDetails.password2" class="col-xs-12 col-sm-6" dense outlined label="Repeat Password" type="password"  autocomplete="new-password" lazy-rules :rules="[ val => val && val == value.registrationDetails.password || 'Does not match password above.' ]"/>
    </div>
</div>
<div class="row" v-if="!isLoggedIn">
    <div class="col-xs-12">
        <q-checkbox v-model="value.registrationDetails.agreeTAC" label="I Agree to ICP's" class="q-pr-xs"/>
        <a href="../html-link.htm" target="popup" onclick="window.open('ClimbICP_Website Terms and Conditions_17 June 2019.pdf','name','width=600,height=800')">Terms and Conditions</a><span v-if="!value.registrationDetails.agreeTAC" style="color:red; font-size:14px; margin-left:10px; padding-left:10px" v-bind:class="blink">Required</span>
    </div>
    <div class="col-xs-12">
        <q-checkbox  v-model="value.registrationDetails.subscribeToEmails" label="Opt in to our email list." class="q-pr-xs">
        <q-tooltip content-style="font-size: 1em; width: 300px; opacity: 80%; background: black; "
                    anchor="center right" self="center left" :offset="[10, 10]"
                    transition-show="flip-right"
                    transition-hide="flip-down">The emails we send are all about getting incredible climbs into the hands of climbers (like you!). You can unsubscribe at any time.</q-tooltip>
        </q-checkbox>
    </div>
</div>
    </q-form> 
  </div>
</template>

<script>
// Would be nice to use this: https://github.com/gocanto/google-autocomplete
import store from '../../store'
export default {
  name: 'ShippingDetails',
  props: {
    value: {
        registrationDetails: Object,
        shippingDetails: Object,
    }
  },
  data () {
    return {
      registrationDetails: {
        email: '',
        password: '',
        password2: '',
        contactName: '',
        subscribeToEmails: false,
        agreeTAC: false,
        registerError: false,
        registerErrorMessage: ''
      },
      stateOptions: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
      filteredStateOptions: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
      dummy:'',
      blink:''
    }
  },
  created (){
    this.value.shippingDetails.country || (this.value.shippingDetails.country = 'Australia')
  },
  computed: {
    isLoggedIn () {
      return (!!this.currentAccount)
    },
    currentUUID () {
      return store.state.auth.currentUUID
    },
    currentAccount () {      
      return store.state.auth.currentAccount
    }
  },
  methods: {
    validateEmail (email) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    async validate () {
      this.blink = "blink_me"
      if(!!this.currentAccount){
        return await this.$refs.form.validate();
      }else{
        return (await this.$refs.form.validate() && this.value.registrationDetails.agreeTAC);
      }
    },
    abortFilterFn (val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.options = this.stateOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
      }, ref => {
        if (val !== '' && ref.options.length > 0 && ref.optionIndex === -1) {
          ref.moveOptionSelection(1, true) // focus the first selectable option and do not update the input-value
          ref.toggleOption(ref.options[ref.optionIndex], true) // toggle the focused option
        }
      })
    },
    filterFn (val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.filteredStateOptions = this.stateOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
        // this.$nextTick(() => {
        //   this.$refs.state.setOptionIndex(0)
        //   this.$refs.state.toggleOption(this.filteredStateOptions[0], true)
        // })
      })
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~quasar-variables';

.blink_me {
  font-weight: bold;
  padding-left: 10px;
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.1;
  }
  40% {
    opacity: 1;
  }

}

</style>
